import styles from './HeroItem.module.scss';

import cx from 'classnames';
import React, { FC } from 'react';

import { ContentLink } from 'components/ContentLink/ContentLink';
import { Card, ICardProps } from 'components/Card/Card';
import { isEntry } from 'utils/EntryUtil';

export const HeroItem: FC<ICardProps> = ({ entry, className, autoPlay, tabIndex, ...props }) => {
  if (!isEntry(entry)) return null;

  const { link, video } = entry.fields;
  const isAutoPlayEnabled = video && autoPlay;

  const card = (
    <Card
      entry={entry}
      mediaClassName={styles.imageWrapper}
      captionClassName={styles.carouselCardCaption}
      className={styles.carouselCard}
      mediaProps={{
        autoPlay,
        muted: isAutoPlayEnabled,
        loop: isAutoPlayEnabled,
        controls: !isAutoPlayEnabled,
      }}
      videoPlayerClassName={styles.videoInHero}
      {...props}
    />
  );

  if (!link) return card;

  return (
    <ContentLink
      className={cx(className, styles.heroItem)}
      entry={link}
      hideTitle
      alwaysRenderChildren
      tabIndex={tabIndex}
    >
      {card}
    </ContentLink>
  );
};
